import React from 'react';
import { withRouter } from 'react-router-dom';
import { withStyles, Grid, ButtonBase, Select, MenuItem, Typography } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import NoMatch from '../../home/NoMatch'
import { MatchItem } from '.';
import MSectionHeader from '../../view/MSectionHeader';
import DateUtils from '../../../control/dateutils';

class MatchTeamMaterial extends React.Component {

    constructor(props) {
        super(props);
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState = () => false;
    }

    _handleChange = (value) => {
        console.log('_handleChange', value);
        this.setState({ curIdex: value });
    }

    _renderItem(name, value) {
        return (
            <Grid container direction='row' justifyContent='space-between' style={{ paddingLeft: 8, paddingRight: 8, marginBottom: 4 }}>
                <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>{name}</Typography>
                <Typography style={{ fontSize: 12, color: '#0D0D0D' }}>{value}</Typography>
            </Grid>
        );
    }

    render() {
        const { classes, data } = this.props;
        return (
            <Grid style={{ width: '100%' }}>
                <Grid style={{ width: '100%', height: 1, backgroundColor: '#F2F2F2' }}></Grid>
                <MSectionHeader title='基本资料' />
                {
                    this._renderItem('球队名称', data.name_zh)
                }
                {
                    this._renderItem('英文名称', data.name_en)
                }
                {
                    this._renderItem('城市', '')
                }
                {
                    this._renderItem('主场', '')
                }
                {
                    this._renderItem('成立时间', (!data.foundation_time || data.foundation_time == 0) ? '未知' : DateUtils.dateFormatYMD(data.foundation_time))
                }
                {
                    this._renderItem('官方网站', data.website)
                }
                <MSectionHeader title='球队介绍' />
                <Typography style={{ fontSize: 12, color: '#0D0D0D', marginLeft: 8, marginRight: 8 }}>{data.desc}</Typography>
            </Grid >
        );
    }
}

export default withRouter(withStyles((theme) => ({
    button: {
        fontSize: 12,
        backgroundColor: '#FC182B',
        color: '#FFF',
        borderRadius: 4,
        width: 75,
        height: 25,
    },
    tableBodyCell1: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#FC182B'
    },
    tableBodyCell: {
        padding: theme.spacing(0.5, 1, 0.5, 1),
        fontSize: 10,
        color: '#0d0d0d'
    },
    icon: {
        width: 20,
        height: 20,
        marginLeft: 4,
        marginRight: 4,
    }
}))(MatchTeamMaterial));